// extracted by mini-css-extract-plugin
export default {"legalSection":"PrivacyPolicyPage_legalSection__NvQ8m","title":"PrivacyPolicyPage_title__c3iYU","article":"PrivacyPolicyPage_article__oWwCp"};